<template>
  <div id="page-user-list" class="p-6">
    <div class="header-custome">
      <div>
        <h3>CheckIn Report</h3>
      </div>
      <div class="chekin-header-right flex justify-end items-center">
        <p>Filter by:&nbsp;</p>
        <div class="filter-tab-area">
          <vs-button
            @click="setfilter('Today')"
            color="#5b058c"
            type="filled"
            class="text-white-today"
          >
            Today</vs-button
          >
          <vs-button
            @click="setfilter('Custom')"
            color="primary"
            type="border"
            class="filter-buttons"
            >Custom</vs-button
          >
          <!-- <vs-button
            @click="setfilter('Advance')"
            color="primary"
            type="border"
            class="filter-buttons mr-1"
            >Advance search</vs-button
          > -->
        </div>
        <div class="location-search-checkin filter-search-area">
          <feather-icon icon="SearchIcon" svgClasses="h-6 w-6" class="ml-1" />

          <vs-input
            class="inputx"
            placeholder="Search by name.."
            v-model="searchQuery"
            @input="updateSearchQuery"
          />
        </div>
        <vs-button
          @click="
            downloadCheckinReports(customFromDate, customToDate, attendeeId)
          "
          color="#00ccfe"
          type="filled"
          class="flex items-center justify-center mr-3 add-loc-btn"
        >
          <img
            src="../../../assets/images/checkin-images/export.svg"
            class="mr-2"
          />
          Export
          <feather-icon
            icon="ChevronDownIcon"
            svgClasses="h-5 w-5"
            class="ml-1"
          />
        </vs-button>
      </div>
    </div>

    <div
      class="attendee-report-name flex justify-start align-items-center"
      v-if="filteredUserName"
    >
      <vs-button
        icon-pack="feather"
        icon="icon-arrow-left"
        class=""
        color="#000"
        type="flat"
        style="font-size: 24px"
        @click="backToGroupReport()"
      ></vs-button>

      <h3 class="mb-0 ml-2">{{ filteredUserName }}</h3>
    </div>

    <div class="" v-if="filterSelection != 'Today'">
      <div
        v-if="filterSelection == 'Custom' && showHideCustomFilter"
        class="custom-advance-search-hld custom-search-hld"
      >
        <!-- <vs-input
          class="inputx"
          placeholder="Choose From Date"
          v-model="from"
        /> -->
        <flat-pickr
          :config="configdateTimePickerStart"
          name="From Date"
          v-model="customFromDate"
          data-vv-validate-on="change"
          placeholder="Choose From Date"
          class="time-pkr"
        />
        <p>To</p>
        <flat-pickr
          :config="configdateTimePickerEnd"
          name="From Date"
          v-model="customToDate"
          data-vv-validate-on="change"
          placeholder="Choose To Date"
          class="time-pkr"
        />
        <div class="ml-0 mt-2 md:mt-0 md:ml-4">
          <vs-button
            color="#00ccfe"
            type="filled"
            class="searchby-date mr-3"
            @click="searchByDateReport()"
            >Search</vs-button
          >
          <vs-button
            color="primary"
            type="border"
            class="reset-date"
            @click="clearCalender()"
            >Reset</vs-button
          >
        </div>
      </div>

      <div
        v-if="filterSelection == 'Advance'"
        class="custom-advance-search-hld advance-search-hld"
      >
        <v-select
          v-model="selected1"
          :options="options1"
          :dir="$vs.rtl ? 'rtl' : 'ltr'"
        />
        <v-select
          v-model="selected2"
          :options="options2"
          :dir="$vs.rtl ? 'rtl' : 'ltr'"
        />
        <v-select
          class="job-role-filtr"
          v-model="selected3"
          :options="options3"
          :dir="$vs.rtl ? 'rtl' : 'ltr'"
        />
        <v-select
          class="job-role-filtr designation-filter"
          v-model="selected4"
          :options="options4"
          :dir="$vs.rtl ? 'rtl' : 'ltr'"
        />
        <v-select
          class="job-role-filtr location-filter"
          v-model="selected5"
          :options="options5"
          :dir="$vs.rtl ? 'rtl' : 'ltr'"
        />
        <div class="ml-0 mt-2 md:mt-0 md:ml-4">
          <vs-button color="#00ccfe" type="filled" class="searchby-date mr-3"
            >Search</vs-button
          >
          <vs-button color="primary" type="border" class="reset-date"
            >Reset</vs-button
          >
        </div>
      </div>
    </div>
    <ag-grid-vue
      v-if="
        getIndividualUserReportsList && getIndividualUserReportsList.length > 0
      "
      ref="agGridTable"
      :gridOptions="gridOptions"
      class="ag-theme-material w-full my-4 ag-grid-table ag-grid table location-grid-table"
      :columnDefs="userReportcolumnDefs"
      :defaultColDef="defaultColDef"
      :rowData="getIndividualUserReportsList"
      rowSelection="multiple"
      rowMultiSelectWithClick="false"
      suppressRowClickSelection="true"
      colResizeDefault="shift"
      :animateRows="true"
      :floatingFilter="true"
      :pagination="true"
      :paginationPageSize="paginationPageSize"
      :suppressPaginationPanel="true"
      :enableRtl="$vs.rtl"
    ></ag-grid-vue>

    <ag-grid-vue
      v-else
      ref="agGridTable"
      :gridOptions="gridOptions"
      class="ag-theme-material w-full my-4 ag-grid-table ag-grid table location-grid-table"
      :columnDefs="columnDefs"
      :defaultColDef="defaultColDef"
      :rowData="getReportsList"
      rowSelection="multiple"
      rowMultiSelectWithClick="false"
      suppressRowClickSelection="true"
      colResizeDefault="shift"
      :animateRows="true"
      :floatingFilter="true"
      :pagination="true"
      :paginationPageSize="paginationPageSize"
      :suppressPaginationPanel="true"
      :enableRtl="$vs.rtl"
    ></ag-grid-vue>
    <vs-pagination :total="totalPages" :max="7" v-model="currentPage" />
  </div>
</template>

<script>
import { AgGridVue } from "ag-grid-vue";
import "@/assets/scss/vuexy/extraComponents/agGridStyleOverride.scss";
import vSelect from "vue-select";
import moduleCheckinReportManagement from "@/store/checkin-report-management/moduleCheckinReportManagement.js";
import moduleCheckinRoleManagement from "@/store/checkin-role-management/moduleCheckinRoleManagement.js";
import CellRendererName from "./cell-renderer/CellRendererName.vue";
import CellRendererRole from "./cell-renderer/CellRendererRole.vue";
import CellRendererLocations from "./cell-renderer/CellRendererLocations.vue";
import CellRendererActions from "./cell-renderer/CellRendererActions.vue";
import moment from "moment-timezone";
import flatPickr from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";
import { bus } from "../../../main";
import ls from "@/common/localStorage";
var vm;

var Session_Event_TZ = ls.getSessionValueByKey("Session_Event_TZ");

export default {
  components: {
    "v-select": vSelect,
    AgGridVue,
    CellRendererName,
    CellRendererRole,
    CellRendererLocations,
    flatPickr,
    CellRendererActions,
  },

  data() {
    return {
      filteredUserName: "",
      filteredDetailedAttendeeReport: [],
      filteredReportParameters: {},
      searchQuery: "",
      showHideCustomFilter: false,
      customToDate: null,
      customFromDate: null,
      attendeeId: null,
      configdateTimePickerStart: {
        //minDate: new Date(),
        onChange: function (val) {
          if (val) vm.configdateTimePickerEnd.minDate = new Date(val);
        },
        enableTime: false,
        enableSeconds: false,
        noCalendar: false,
        dateFormat: "Y-m-d",
        defaultHour: 24,
        defaultMinute: 0,
        time_24hr: false,
      },
      configdateTimePickerEnd: {
        minDate: null,
        enableTime: false,
        enableSeconds: false,
        noCalendar: false,
        dateFormat: "Y-m-d",
        defaultHour: 24,
        defaultMinute: 0,
        time_24hr: false,
      },
      currentDate: "",
      CurrentDatePlusOneDay: "",
      checkinRoleList: [],
      gridApi: null,
      gridOptions: {},
      userReportcolumnDefs: [
        {
          headerName: "Date",
          field: "Date",
          filter: true,
          width: 200,
          unSortIcon: true,
        },
        {
          headerName: "CHECKIN-TIME",
          field: "CheckIn",
          filter: true,
          width: 200,
          unSortIcon: true,
        },
        {
          headerName: "CHECKOUT-TIME",
          field: "CheckOut",
          filter: true,
          width: 200,
          unSortIcon: true,
        },
        {
          headerName: "Location",
          field: "Location",
          filter: true,
          width: 200,
          unSortIcon: true,
        },
        {
          headerName: "TOTAL TIME",
          field: "TotalDurationOfUser",
          filter: true,
          width: 200,
          unSortIcon: true,
        },
      ],
      columnDefs: [
        {
          headerName: "Name",
          field: "Name",
          filter: true,
          width: 200,
          unSortIcon: true,
          cellRendererFramework: "CellRendererName",
          cellRendererParams: (params) => {
            return {
              Name: params.data.Name,
              Email: params.data.Email,
              ProfilePictureURL: params.data.ProfilePictureURL,
              AttendeeId: params.data.AttendeeId,
            };
          },
        },
        // {
        //   headerName: "Email",
        //   field: "Email",
        //   filter: true,
        //   width: 200,
        //   unSortIcon: true,
        // },
        {
          headerName: "Designation",
          field: "Designation",
          filter: true,
          width: 200,
          unSortIcon: true,
        },
        {
          headerName: "Role",
          field: "CheckinRoles",
          filter: true,
          width: 200,
          unSortIcon: true,
          cellRendererFramework: "CellRendererRole",
          cellRendererParams: (params) => {
            return {
              CheckinRoles: params.data.CheckinRoles,
              checkinRoleList: this.checkinRoleList,
            };
          },
        },
        {
          headerName: "Location",
          field: "Location",
          filter: true,
          width: 200,
          unSortIcon: true,
          cellRendererFramework: "CellRendererLocations",
          cellRendererParams: (params) => {
            return {
              Location: params.data.Location,
            };
          },
        },
        {
          headerName: "Total Time",
          field: "TotalDuration",
          filter: true,
          width: 200,
          unSortIcon: true,
        },
        {
          headerName: "Actions",
          filter: false,
          sortable: false,
          width: 100,
          cellRendererFramework: "CellRendererActions",
          cellRendererParams: (params) => {
            return {
              data: params.data,
              filteredReportParameters: this.filteredReportParameters,
            };
          },
          pinned: "right",
        },
      ],
      defaultColDef: {
        sortable: true,
        resizable: true,
        suppressMenu: true,
      },
      filterSelection: "Today",
      value1: "",
      value2: "",
      value3: "",
      options1: [
        { id: 1, label: "Select year" },
        { id: 2, label: "2011" },
        { id: 3, label: "2012" },
        { id: 4, label: "2012" },
        { id: 5, label: "2012" },
      ],
      selected1: { id: 1, label: "Select year" },

      options2: [
        { id: 6, label: "Select month" },
        { id: 7, label: "JAN" },
        { id: 8, label: "FEB" },
        { id: 9, label: "MAR" },
        { id: 10, label: "ARP" },
      ],
      selected2: { id: 6, label: "Select month" },

      options3: [
        { id: 11, label: "Select role" },
        { id: 12, label: "Interns" },
        { id: 13, label: "Maintainer" },
        { id: 14, label: "Admin" },
        { id: 15, label: "First Aiders" },
      ],
      selected3: { id: 11, label: "Select role" },

      options4: [
        { id: 16, label: "Select Designation" },
        { id: 17, label: "Account Executive" },
        { id: 18, label: "Marketing manager" },
        { id: 19, label: "Markering Director" },
        { id: 20, label: "Brand Manager" },
      ],
      selected4: { id: 16, label: "Select Designation" },

      options5: [
        { id: 21, label: "Select Location" },
        { id: 22, label: "Mississauga" },
        { id: 23, label: "Illinois" },
        { id: 24, label: "Spokane" },
        { id: 25, label: "Houston" },
      ],
      selected5: { id: 16, label: "Select location" },
      reportsData: [],
      attendeeReportsData: [],
      components: {
        CellRendererName,
        CellRendererRole,
        CellRendererLocations,
        CellRendererActions,
      },
    };
  },

  watch: {},

  computed: {
    paginationPageSize() {
      if (this.gridApi) return this.gridApi.paginationGetPageSize();
      else return 10;
    },
    totalPages() {
      if (this.gridApi) return this.gridApi.paginationGetTotalPages();
      else return 0;
    },
    currentPage: {
      get() {
        if (this.gridApi) return this.gridApi.paginationGetCurrentPage() + 1;
        else return 1;
      },
      set(val) {
        this.gridApi.paginationGoToPage(val - 1);
      },
    },
    getReportsList() {
      return this.reportsData;
    },
    getIndividualUserReportsList() {
      return this.filteredDetailedAttendeeReport;
    },
  },

  methods: {
    backToGroupReport() {
      this.attendeeId = "";
      this.filteredUserName = "";

      this.filteredDetailedAttendeeReport = [];

      this.fetchCheckinReports(this.customFromDate, this.customToDate);
    },
    SetTimeByZone: function (strDateTime, timeZone) {
      var date = moment
        .tz(strDateTime, timeZone)
        .format("MMM DD, YYYY hh:mm A");
      return date;
    },
    clearCalender() {
      this.customFromDate = null;
      this.customToDate = null;
    },
    updateSearchQuery(val) {
      console.log("called====", val);

      this.gridApi.setQuickFilter(val);
    },
    searchByDateReport() {
      debugger
      console.log("customFromDate====", this.customFromDate);
      console.log("toFromDate====", this.customToDate);
      if (this.customFromDate && this.customToDate) {
        this.fetchCheckinReports(this.customFromDate, this.customToDate);
      }
    },
    setfilter(val) {
      if (val == "Custom") {
        vm.showHideCustomFilter =
          vm.showHideCustomFilter == true ? false : true;
      }
      this.filterSelection = val;
    },
    fetchCheckinReports(
      customFromDate = null,
      customToDate = null,
      attendeeId = null
    ) {
      debugger
      const now = moment();
      const tomorrow = moment(now).add(1, "day");
      const datetime = now.format("YYYY-MM-DD 00:00:00");
      const tomorrowFormatted = tomorrow.format("YYYY-MM-DD 00:00:00");

      this.$vs.loading();
      this.reportsData = [];
      var data = {};
      if (customFromDate && customToDate) {
        data = {
          from: moment(customFromDate).format("YYYY-MM-DD 00:00:00"),
          to: moment(customToDate).format("YYYY-MM-DD 00:00:00"),
          users: attendeeId ? attendeeId : null,
        };
      } else {
        data = {
          from: datetime,
          to: tomorrowFormatted,
          users: attendeeId ? attendeeId : null,
        };
      }

      this.filteredReportParameters = data;

      this.$store
        .dispatch("checkinreportManagement/fetchGeoCheckinReports", data)
        .then((res) => {
          debugger;
          console.log("res====", res);
          //   res.data.data.map();
          //   this.reportsData = res.data.data;
          this.reportsData = [];
          if (res.data) {
            if (res.data.data && res.data.data.length == 0) {
            } else {
              if (attendeeId) {
                var detailedAttendeeReport = {};
                vm.filteredDetailedAttendeeReport = [];
                vm.filteredUserName = "";
                if (res.data.data && res.data.data.length > 0) {
                  res.data.data.map((reportData) => {
                    const date1 = new Date(customFromDate);

                    const date2 = new Date(customToDate);

                    const diffTime = Math.abs(date2 - date1);
                    const diffDays = Math.ceil(
                      diffTime / (1000 * 60 * 60 * 24)
                    );

                    const startDate = date1;

                    // Define the number of days to add
                    const numDays = diffDays;

                    // Calculate the end date by adding the number of days to the starting date
                    const endDate = new Date(
                      startDate.getTime() + numDays * 24 * 60 * 60 * 1000
                    );

                    // Loop through the range and log the remaining dates
                    let currentDate = startDate;

                    while (currentDate <= endDate) {
                      //var checkedInDetails = [];
                      debugger;

                      reportData.data.map((checkindata) => {
                        console.log("currentDate:" + moment(currentDate).format("DD"));
                        console.log(
                          "checkindata:" +
                            moment(checkindata.checkin.recordedOn.value).format(
                              "DD"
                            )
                        );
                        if (
                          moment(currentDate).format("DD") ==
                          moment(checkindata.checkin.recordedOn.value).format(
                            "DD"
                          )
                        ) {
                          detailedAttendeeReport.Location =
                            checkindata.location.Name;
                          if (checkindata.checkin) {
                            detailedAttendeeReport.CheckIn = vm.SetTimeByZone(
                              checkindata.checkin.recordedOn.value,
                              Session_Event_TZ
                            );
                          }
                          if (checkindata.checkout) {
                            detailedAttendeeReport.CheckOut = vm.SetTimeByZone(
                              checkindata.checkout.recordedOn.value,
                              Session_Event_TZ
                            );
                          }
                          if (checkindata.checkin && checkindata.checkout) {
                            const diff =
                              new Date(
                                detailedAttendeeReport.CheckOut
                              ).getTime() -
                              new Date(
                                detailedAttendeeReport.CheckIn
                              ).getTime();

                            const hours = Math.floor(diff / (1000 * 60 * 60));
                            const minutes = Math.floor(
                              (diff % (1000 * 60 * 60)) / (1000 * 60)
                            );
                            const duration = `${hours
                              .toString()
                              .padStart(2, "0")}:${minutes
                              .toString()
                              .padStart(2, "0")}`;
                            detailedAttendeeReport.TotalDurationOfUser =
                              duration;
                          } else {
                            const diff =
                              new Date().getTime() -
                              new Date(
                                detailedAttendeeReport.CheckIn
                              ).getTime();

                            const hours = Math.floor(diff / (1000 * 60 * 60));
                            const minutes = Math.floor(
                              (diff % (1000 * 60 * 60)) / (1000 * 60)
                            );
                            const duration = `${hours
                              .toString()
                              .padStart(2, "0")}:${minutes
                              .toString()
                              .padStart(2, "0")}`;
                            detailedAttendeeReport.TotalDurationOfUser =
                              duration;
                          }

                          const tempcurrentDate = new Date(
                            currentDate.getTime()
                          );
                          const options = {
                            weekday: "short",
                            day: "2-digit",
                            month: "short",
                            year: "numeric",
                          };

                          detailedAttendeeReport.Date =
                            tempcurrentDate.toLocaleDateString(
                              "en-US",
                              options
                            );

                          detailedAttendeeReport.Name =
                            reportData.attendee.Name;
                          vm.filteredUserName = reportData.attendee.Name;

                          vm.filteredDetailedAttendeeReport.push(
                            detailedAttendeeReport
                          );

                          detailedAttendeeReport = {};
                        }
                      });

                      currentDate.setDate(currentDate.getDate() + 1);
                    }
                    this.$vs.loading.close();
                    this.pageLoaded = true;

                    console.log(
                      "filteredDetailedAttendeeReport====",
                      this.filteredDetailedAttendeeReport
                    );
                  });
                }
              } else {
                var tempReport = {};
                res.data.data.map((reportData) => {
                  var duration = 0;
                  var locations = [];
                  reportData.data.map((reportCheckins) => {
                    console.log("reportCheckins===", reportCheckins);
                    if (reportCheckins) {
                      duration += reportCheckins.duration
                        ? reportCheckins.duration
                        : 0;

                      locations.push(reportCheckins.location);
                    } else {
                      duration += 0;

                      locations.push([]);
                    }
                  });
                  tempReport = {
                    Name: reportData.attendee.Name,
                    Email: reportData.attendee.Email,
                    Designation: reportData.attendee.Designation,
                    TotalDuration:
                      moment.utc(duration * 1000).format("HH:mm") + " hrs",
                    ProfilePictureURL: reportData.attendee.ProfilePictureURL,
                    CheckinRoles: reportData.attendee.CheckinRoles,
                    Location: locations,
                    AttendeeId: reportData.attendee.AttendeeId,
                  };
                  this.reportsData.push(tempReport);
                });
              }
            }
          }
          this.$vs.loading.close();
          this.pageLoaded = true;
        });
    },
    downloadCheckinReports(customFromDate, customToDate, attendeeId) {
      var vm = this;
      debugger;
      const now = moment();
      const tomorrow = moment(now).add(1, "day");
      const datetime = now.format("YYYY-MM-DD 00:00:00");
      const tomorrowFormatted = tomorrow.format("YYYY-MM-DD 00:00:00");
      this.$vs.loading();
      var data = {};
      debugger;
      if (customFromDate && customToDate) {
        data = {
          from: moment(customFromDate).format("YYYY-MM-DD 00:00:00"),
          to: moment(customToDate).format("YYYY-MM-DD 00:00:00"),
          users: attendeeId ? attendeeId : null,
        };
      } else {
        data = {
          from: datetime,
          to: tomorrowFormatted,
          users: null,
          users: attendeeId ? attendeeId : null,
        };
      }
      this.filteredReportParameters = data;
      this.$store
        .dispatch("checkinreportManagement/downloadGeoCheckinReports", data)
        .then((res) => {
          this.$vs.loading.close();
        });
    },
    fetchCheckinRoles() {
      var self = this;

      this.$store
        .dispatch("checkinRoleManagement/fetchGeoCheckinRoles")
        .then((res) => {
          self.checkinRoleList = [];

          res.data[0].map(function (item) {
            if (item.IsPublished) {
              self.checkinRoleList.push({
                RoleId: item.RoleId,
                Name: item.Name,
                Color: item.Color,
                ImageUrl: item.ImageUrl,
                IsDefault: false,
                Primary: "Make It Primary",
              });
            }
          });
          //vm.checkinRoleList = res.data[0];
        });
    },
  },

  mounted() {
    this.gridOptions.api.showLoadingOverlay();
    this.gridApi = this.gridOptions.api;

    /* =================================================================
      NOTE:
      Header is not aligned properly in RTL version of agGrid table.
      However, we given fix to this issue. If you want more robust solution please contact them at gitHub
    ================================================================= */
    if (this.$vs.rtl) {
      const header = this.$refs.agGridTable.$el.querySelector(
        ".ag-header-container"
      );
      header.style.left = `-${String(
        Number(header.style.transform.slice(11, -3)) + 9
      )}px`;
    }
  },

  created() {
    vm = this;
    if (!moduleCheckinRoleManagement.isRegistered) {
      this.$store.registerModule(
        "checkinRoleManagement",
        moduleCheckinRoleManagement
      );
      moduleCheckinRoleManagement.isRegistered = true;
    }
    this.fetchCheckinRoles();
    if (!moduleCheckinReportManagement.isRegistered) {
      this.$store.registerModule(
        "checkinreportManagement",
        moduleCheckinReportManagement
      );
      moduleCheckinReportManagement.isRegistered = true;
    }

    this.filterSelection = "Today";

    this.fetchCheckinReports();

    bus.$on("viewDetails", async (val) => {
      vm.attendeeId = val.data.AttendeeId;
      vm.fetchCheckinReports(
        val.filteredReportParameters.from,
        val.filteredReportParameters.to,
        val.data.AttendeeId
      );
    });
  },
};
</script>

<style>
.text-white-today .vs-button-text {
  color: #fff !important;
}
</style>